module.exports = __webpack_public_path__ + "static/media/arrow-left-hover.3c628315.svg";